import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import { Base64 } from "js-base64";
// RSA公钥
const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDI7HE0aW9ILCMkfoAJYmAG+5RBRhU2Itebf04GUtnYMuR6Rl1GJKec7JKuM/8xSindH4jn6Vz3oARTjbCn4CxjbtQPys5i8VeXxgzzqhE34LY0Rt62Qy8UVS113454DTwZZR9BjmPQSxMaftQHMgeDjXVwLUt0a6CmRiZKOjw8WQIDAQAB"

// 处理Base64格式的公钥，移除头尾标记和换行符
const processPublicKey = (key) => {
  return key.replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g, '')
}

// 生成随机AES密钥（32字节，256位）
// export const generateAESKey = () => {
//   try {
//     const randomWords = CryptoJS.lib.WordArray.random(32); // 32字节 = 256位
//     console.log('AES密钥：', randomWords);

//     // 使用Base64编码 - 这是最安全可靠的方式
//     // Base64字符串本身就是有效的UTF-8字符串
//     return Base64.encode(randomWords)
//     return CryptoJS.enc.Base64.stringify(randomWords);
//   } catch (error) {
//     console.error('生成AES密钥失败:', error);
//     throw error;
//   }
// }

export const generateAESKey = () => {
  // 定义可能的字符
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  // 生成32位随机字符串
  for (let i = 0; i < 32; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  // return Base64.encode(result);
  return result;
}


// RSA加密
export const rsaEncrypt = (data) => {
  try {
    const encryptor = new JSEncrypt()
    const formattedKey = `-----BEGIN PUBLIC KEY-----\n${processPublicKey(publicKey)}\n-----END PUBLIC KEY-----`
    // console.log('RSA公钥：', formattedKey);

    encryptor.setPublicKey(formattedKey)
    return encryptor.encrypt(data)
  } catch (error) {
    console.error('RSA加密失败:', error)
    throw error
  }
}

// AES加密
export const aesEncrypt = (data, key) => {
  try {
    const dataStr = typeof data === 'object' ? JSON.stringify(data) : data;
    const iv = CryptoJS.lib.WordArray.random(16);
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);

    const encrypted = CryptoJS.AES.encrypt(dataStr, keyUtf8, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv,
    })

    const combined = iv.concat(encrypted.ciphertext);
    const result = combined.toString(CryptoJS.enc.Base64);


    return result
  } catch (error) {
    console.error('AES加密失败:', error)
    throw error
  }
}

// AES解密
export const aesDecrypt = (encryptedData, key) => {
  try {
    
    // Base64解码
    const decoded = CryptoJS.enc.Base64.parse(encryptedData);
    const iv = CryptoJS.lib.WordArray.create(decoded.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(decoded.words.slice(4));
    
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key)
    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, keyUtf8, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);

    try {
      return JSON.parse(decryptedStr)
    } catch {
      return decryptedStr
    }
  } catch (error) {
    console.error('AES解密失败:', error)
    throw error
  }
}

// 将Base64转换为十六进制字符串
export const base64ToHex = (base64) => {
  const raw = atob(base64)
  let hex = ''
  for (let i = 0; i < raw.length; i++) {
    const hexByte = raw.charCodeAt(i).toString(16).padStart(2, '0')
    hex += hexByte
  }
  return hex
}